import Grid from '@mui/material/Grid';
import React from 'react';
import { TextV2 } from '@insights-ltd/design-library/components';
import { styled } from '@mui/material';

export const JobDetailField = ({ children }: { children: React.ReactNode }) => (
  <Grid
    container
    spacing={2}
    sx={{
      alignItems: 'flex-end',
      padding: '0',
    }}
  >
    {children}
  </Grid>
);

const StyledText = styled(TextV2)({ textTransform: 'uppercase' });

export const JobFieldLabel = ({ text }: { text: string }) => (
  <Grid sx={{ width: '130px' }}>
    <StyledText variant="bodyBold" color="textSecondary">
      {text}
    </StyledText>
  </Grid>
);

export const JobDetailDescription = ({
  children,
}: {
  children: React.ReactNode;
}) => <Grid>{children}</Grid>;
